const buildAreaToSchemaMapper = (buildArea) => {
  return buildArea.map((mark) =>
    mark.map((row) => {
      if (row.type === "line") {
        return [[{ line: row.line }]];
      }

      return row.data.map((col) => col.data.map((field) => {
        let finalField = {};
        if (field.ui_type === "title")
          finalField = { title: field.title };
        else if (field.ui_type === "customComponent")
          finalField = { customComponent: field.customComponent};
        else if (field.ui_type === "db_field")
          finalField = { field: field.field };
        if (field.customWidth !== "auto") {
          finalField.className = field.customWidth;
        }

        if (field.customClass) {
          finalField.className = finalField.className
            ? `${finalField.className} ${field.customClass}`
            : field.customClass;
        }

        return finalField;
      }))
    }
    )
  )
};

export default buildAreaToSchemaMapper;